var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/images/avatars/image-amyrobson.png": "f32e",
	"./assets/images/avatars/image-amyrobson.webp": "9d9d",
	"./assets/images/avatars/image-juliusomo.png": "f166",
	"./assets/images/avatars/image-juliusomo.webp": "5add",
	"./assets/images/avatars/image-maxblagun.png": "b1a7",
	"./assets/images/avatars/image-maxblagun.webp": "1737",
	"./assets/images/avatars/image-ramsesmiron.png": "0bd9",
	"./assets/images/avatars/image-ramsesmiron.webp": "b9d5",
	"./assets/images/favicon-32x32.png": "f245",
	"./assets/images/icon-delete.svg": "11ca",
	"./assets/images/icon-edit.svg": "eaaf",
	"./assets/images/icon-minus.svg": "b398",
	"./assets/images/icon-plus.svg": "77ea",
	"./assets/images/icon-reply.svg": "7b82",
	"./assets/sass/_base.sass": "583a",
	"./assets/sass/_mixins.sass": "9882",
	"./assets/sass/_typography.sass": "bbe1",
	"./assets/sass/_variables.sass": "88ab",
	"./assets/sass/styles.sass": "f251",
	"./components/AddComment": "d6de",
	"./components/AddComment.vue": "d6de",
	"./components/AddReply": "b806",
	"./components/AddReply.vue": "b806",
	"./components/Comment": "4ea3",
	"./components/Comment.vue": "4ea3",
	"./components/CommentSection": "4b9b",
	"./components/CommentSection.vue": "4b9b",
	"./components/Modal": "714b",
	"./components/Modal.vue": "714b",
	"./data/data": "0a26",
	"./data/data.json": "0a26",
	"./data/input-data": "ab12",
	"./data/input-data.js": "ab12",
	"./main": "56d7",
	"./main.js": "56d7",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";